import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BusinessDetailPage from "../pages/business-detail/page";
import CaseDetailPage from "../pages/case-detail/page";
import NewsDetailPage from "../pages/news-detail/page";
import AdminLayout from "../pages/admin/components/AdminLayout";
import AdminProtectedRoute from "../pages/admin/components/AdminProtectedRoute";
import AdminLoginPage from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import BusinessCMS from "../pages/admin/cms/BusinessCMS";
import AIProductsCMS from "../pages/admin/cms/AIProductsCMS";
import CasesCMS from "../pages/admin/cms/CasesCMS";
import NewsCMS from "../pages/admin/cms/NewsCMS";
import HeroCMS from "../pages/admin/cms/HeroCMS";
import UserManagementPage from "../pages/admin/users/page";
import LogsPage from "../pages/admin/logs/page";
import RoleGuard from "../pages/admin/components/RoleGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/business/:id",
    element: <BusinessDetailPage />,
  },
  {
    path: "/case/:id",
    element: <CaseDetailPage />,
  },
  {
    path: "/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: <AdminProtectedRoute />,
    children: [
      {
        path: "",
        element: <AdminLayout />,
        children: [
          { path: "", element: <AdminDashboard /> },
          { path: "cms/business", element: <BusinessCMS /> },
          { path: "cms/ai-products", element: <AIProductsCMS /> },
          { path: "cms/cases", element: <CasesCMS /> },
          { path: "cms/news", element: <NewsCMS /> },
          { path: "cms/hero", element: <HeroCMS /> },
          { path: "users", element: <RoleGuard path="/admin/users"><UserManagementPage /></RoleGuard> },
          { path: "logs", element: <RoleGuard path="/admin/logs"><LogsPage /></RoleGuard> },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
